export default __webpack_public_path__ + "static/media/icon_company.e6f77ec8.svg";